




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {reformatDate} from "@/data/sources/dates"
import {executeQuery} from "@/data/repos/query"

@Component({
  components: {
    DataGrid,
  },
})
export default class JobsAllocatedInAMonthPPMJobsCompletedDrillDown extends Vue {
  @Prop() public args!: {
    month: number,
    year: number,
    hdPPMRepairAll: number,
    category: number,
    status: number,
  }
  public fields = [
    {name: 'PPM_Occ_Id', title: 'PPM occ id', dataType: DataType.Number, sort: 1},
    {name: 'PPM_Due_Date', title: 'Due date', dataType: DataType.Date, sort: 1},
    {name: 'PPM_Short_Desc', title: 'Short description', dataType: DataType.Text, sort: 1},
    {name: 'Site_Desc', title: 'Site', dataType: DataType.Text, sort: 1},
    {name: 'Building_Desc', title: 'Building', dataType: DataType.Text, sort: 1},
    {name: 'PPM_Asset_id', title: 'Asset id', dataType: DataType.Number, sort: 1},
    {name: 'PPM_Status', title: 'Status', dataType: DataType.Text, sort: 1},
  ]
  private currentMonth: number = new Date().getMonth() + 1
  private currentYear: number = new Date().getFullYear()

  public getData(offset: number = 0, limit: number = 250) {

    // @userID int,
    // @month int,
    // @year int,
    // @ppmRepairAll int,
    // @category nvarchar(10),
    // @contractor nvarchar(20),
    // @usecategory int,
    // @status int -- 0-Outstanding, 1-Done, 2-Cancelled, 3-Failed, 4-Supressed

    // GetJobsAllocatedInAMonth/' + locationId + '/1/' + month + '/' + year + '/1/0/' + inhouseContractor + '/0',
    const p = this.args
    return executeQuery("" +
      "FMS_DB",
      "inhousePPMJobsCompletedForMonthGrid",
      {category: p.category, year: p.year, month: p.month, status: p.status},
      this.filter,
      offset, limit)
  }

  private filter(data: any[]): any {
    const filteredData: any[] = []
    for (const item of data) {
      filteredData.push({
        ...item,
        PPM_Due_Date: reformatDate(item.PPM_Due_Date),
      })
    }
    return filteredData
  }
}
